import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/catch';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { GlobalService } from '../global/global.service';

@Injectable()
export class TermsService {

  // store the URL so we can redirect after logging in
  constructor(private http: HttpClient, private globalService: GlobalService) {
  }
  url = this.globalService.urlContaE();
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  getToken() {
    return localStorage.getItem('key');
  }


  public terms(): Observable<any> {
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(this.url + 'api/User/Contract_Show', '', {headers: this.headers})
      .catch(error => {
        return Observable.throw('An error occurred:', error.message);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/terms/terms.service.ts